import { useMemo } from 'react';
import { format as formatDateFns, parseISO } from 'date-fns';
import styled from 'styled-components';

import { UK_COUNTRY } from '@lib/utils/constants';

type PostDatePostedProps = {
  jobs_board_date_time_posted: string | null;
  projectCountry: string | undefined;
};
export const PostDatePosted = ({
  jobs_board_date_time_posted,
  projectCountry,
}: PostDatePostedProps) => {
  const finalDateFormat = useMemo(() => {
    return projectCountry === UK_COUNTRY ? 'd MMM, yyyy' : 'MMM d, yyyy';
  }, [projectCountry]);

  const postedDateDisplay = useMemo(() => {
    if (!jobs_board_date_time_posted) {
      return '-';
    }

    return `Posted ${formatDateFns(
      parseISO(jobs_board_date_time_posted),
      finalDateFormat
    )}`;
  }, [jobs_board_date_time_posted, finalDateFormat]);
  return <StyledContainer>{postedDateDisplay}</StyledContainer>;
};

const StyledContainer = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.palette.text[9]};

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`;
